import { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import API from './custom/API'
import CalendarForm from './forms/CalendarForm'
import Loading from './custom/Loading'

const CalendarPost = () => {
	let { id } = useParams()
	const [showLoading, setShowLoading] = useState(false)

	return (
		<>
			<Loading isVisible={showLoading}/>
			<CalendarForm id={id} setShowLoading={setShowLoading} />
		</>
	)
}

export default CalendarPost